import { render, staticRenderFns } from "./CommunityPost.vue?vue&type=template&id=3d9ec83c&scoped=true&"
import script from "./CommunityPost.vue?vue&type=script&lang=js&"
export * from "./CommunityPost.vue?vue&type=script&lang=js&"
import style0 from "./CommunityPost.vue?vue&type=style&index=0&id=3d9ec83c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9ec83c",
  null
  
)

export default component.exports